// Shared reviews data for Family Home LLC
// NOTE: This is a small snapshot subset for UI rendering, not the full set of client reviews.
// Update with new highlights; avoid implying only these exist.
export const reviews = [
  {
    id: 1,
    author: 'Jennifer R.',
    meta: 'Family Member',
    date: '2 weeks ago',
    text: `Family Home LLC provides compassionate, reliable care. Our loved one feels safe, respected, and truly at home. Staff communicate clearly and consistently, and the home is always warm and welcoming.`
  },
  {
    id: 2,
    author: 'Yanet T.',
    meta: 'Family Member',
    date: '3 weeks ago',
    text: `The staff are patient, attentive, and respectful. They always keep us informed and make sure our family member is comfortable and engaged with meaningful activities.`
  },
  {
    id: 3,
    author: 'Yuele T.',
    meta: 'Provider Partner',
    date: '2 days ago',
    text: `Family Home LLC collaborates well with providers and offers consistent, person-centered support. They prioritize safety and dignity while keeping communication clear and proactive.`
  }
];
